import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Process from './components/Process';
import QuoteSection from './components/QuoteSection';
import Testimonials from './components/Testimonials';
import CtaSection from './components/CtaSection';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SEO from './components/SEO';
import WeddingPlanning from './pages/WeddingPlanning';
import ServiceTasks from './pages/ServiceTasks';
import FairyTaleStory from './pages/FairyTaleStory';
import LoveBlossomsStory from './pages/LoveBlossomsStory';
import VowExchangeStory from './pages/VowExchangeStory';
import FloralCorridorStory from './pages/FloralCorridorStory';
import FashionExplosionStory from './pages/FashionExplosionStory';
import VerizonAwardsStory from './pages/VerizonAwardsStory';
import { Toaster } from './components/ui/toaster';

const HomePage = () => (
  <div className="bg-[#0a0a0a] min-h-screen">
    <SEO
      title="Dion Magee Events & Weddings | Luxury Wedding & Event Designer"
      description="Where dreams become legend. Bespoke wedding planning and corporate event design by Sir Dion Magee — destination weddings, private estates, and unforgettable productions."
      path="/"
      image="/og-image.jpg"
    />
    <Navbar />
    <Hero />
    <Marquee />
    <About />
    <Services />
    <QuoteSection />
    <Portfolio />
    <Process />
    <Testimonials />
    <CtaSection />
    <Contact />
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/wedding-planning" element={<WeddingPlanning />} />
          <Route path="/service-tasks" element={<ServiceTasks />} />
          <Route path="/portfolio/fairy-tale-wedding" element={<FairyTaleStory />} />
          <Route path="/portfolio/our-love-blossoms" element={<LoveBlossomsStory />} />
          <Route path="/portfolio/the-vow-exchange" element={<VowExchangeStory />} />
          <Route path="/portfolio/the-floral-corridor" element={<FloralCorridorStory />} />
          <Route path="/portfolio/fashion-explosion-production" element={<FashionExplosionStory />} />
          <Route path="/portfolio/the-verizon-excellence-awards" element={<VerizonAwardsStory />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
